module.exports = __webpack_public_path__ + "img/amazon-halo-fitness-tracker-band-coming-soon-thoughts-apple-watch-fitbit.1186c4a2.png";